"use strict";

import observer from './modules/observer';
import {v4 as uuid} from "uuid";
import {Modal} from "bootstrap";

const icing = {

    watch(selector, callback, key) {
        switch (typeof callback) {
            case 'function':
                observer.add(selector, callback, key);
                break;
            case 'string':
                if (observer[callback]) {
                    return observer[callback](selector, key);
                } else {
                    return observer.remove(selector, callback);
                }
        }
        return document.body.querySelectorAll(selector);
    },

    modal(url, options = {}) {

        url = url ?? window.location.href;
        options = options ?? {};

        const id = options.id ?? 'modal-' + uuid();
        const size = 'modal-' + (options.size ?? 'xl');
        const classes = options.class ?? 'modal-dialog-scrollable';

        const container = document.createElement('div');
        container.id = id;
        container.classList.add('modal', 'fade');
        container.setAttribute('tabindex', -1);
        container.setAttribute('aria-labelledby', id + 'Label');
        if (options.backdrop) {
            container.setAttribute('data-bs-backdrop', options.backdrop);
        }

        container.innerHTML = `
            <div class="modal-dialog ${size} ${classes}">
                <div class="modal-content">
                    <div
                        class="d-flex justify-content-center align-items-center"
                        style="height: 70vh"
                    >
                        <div
                            class="spinner-grow"
                            style="width: 3rem;height: 3rem;"
                            role="status"
                        >
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>`;
        document.body.appendChild(container);
        container.addEventListener('hidden.bs.modal', () => container.remove());

        const modal = new Modal(container, {focus: false});
        modal.show();

        fetch(url, {
            headers: {
                "X-Requested-With": "XMLHttpRequest",
                "X-Layout": "modal"
            }
        })
            .then(r => r.text())
            .then(content => {
                //check if the container still exists
                if (!container.isConnected) {
                    return;
                }

                container.firstElementChild.innerHTML = content;

                const scripts = container.getElementsByTagName('script');
                for (let i = 0; i < scripts.length; i++) {
                    const script = scripts[i];
                    const newScript = document.createElement('script');

                    // Copy all attributes.
                    for (let j = 0; j < script.attributes.length; j++) {
                        const attr = script.attributes[j];
                        newScript.setAttribute(attr.name, attr.value);
                    }

                    // Copy the script's content.
                    newScript.appendChild(document.createTextNode(script.innerHTML));

                    // Replace the old script tag with the new one.
                    script.parentNode.replaceChild(newScript, script);
                }

            });
    }

};

window.icing = icing;
